module.exports = __webpack_public_path__ + "static/img/city-mob-gold-ar-1.36fccd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gold-about/city-mob-gold-ar-1.png
// module id = 1067
// module chunks = 173